import React from 'react';
import '../styles/components/Campaign.css';

/**
 * キャンペーンバナーコンポーネント
 * 画面上部に常時表示され、テストプレイヤーキャンペーン情報を表示
 *
 * @param {Object} props
 * @param {Object} props.campaign - キャンペーン情報 { active, name, endDate, feedbackUrl }
 */
const CampaignBanner = ({ campaign }) => {
  // キャンペーンがアクティブでない場合は非表示
  if (!campaign || !campaign.active) {
    return null;
  }

  // 日付フォーマット
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}月${day}日まで`;
  };

  return (
    <div className="campaign-banner" role="banner" aria-label="キャンペーン情報">
      <span className="campaign-banner__icon" aria-hidden="true">
        ✨
      </span>
      <div className="campaign-banner__content">
        <span className="campaign-banner__text">
          つむぎを一緒につくろう
        </span>
        {campaign.endDate && (
          <span className="campaign-banner__date">
            {formatDate(campaign.endDate)}
          </span>
        )}
        {campaign.feedbackUrl && (
          <a
            href={campaign.feedbackUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="campaign-banner__link"
          >
            感想を教えてね
            <span className="campaign-banner__link-icon" aria-hidden="true">
              →
            </span>
          </a>
        )}
      </div>
    </div>
  );
};

export default CampaignBanner;
